import duck from '../../core/conversations';

const conversations = duck({});

export const { operations, operationsResponsive } = conversations;
export const { selectors, selectorsResponsive } = conversations;
export default conversations;
